import React from 'react'
import { useSelector } from 'react-redux'
import { getWapi } from '@core/Areas/Kambi/helpers'
import { selectIsBetslipMaximized, selectIsVisible } from '@core/Areas/Kambi/Store/selectors'

export const useKambiVisible = (): [isKambiVisible: boolean, isKambiBetslipMaximized: boolean] => {
  const isKambiVisible = useSelector(selectIsVisible)
  const isKambiBetslipMaximized = useSelector(selectIsBetslipMaximized)

  React.useEffect(() => {
    if (!isKambiVisible) return undefined

    getWapi().then(wapi => {
      // On entering sports route, show betslip minimized
      wapi.set(wapi.BETSLIP_MAXIMIZED, { maximized: false })
    })
  }, [isKambiVisible])

  return [isKambiVisible, isKambiBetslipMaximized]
}
